import { TranslateService } from "@ngstack/translate";
import { Component, OnInit, Inject } from "@angular/core";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";

import { SoundEnum } from "src/app/enums/sound.enum";
import { ITeacherFree } from "src/app/interfaces/teacher-freeTime";
import { ITeacher } from "./../../../../interfaces/course-teacher";
import { SnackBarService } from "src/app/services/common/snackBar.service";
import { CourseService } from "src/app/services/http/business/course/course.service";
import { IAddTeacherAfterCourse } from "src/app/interfaces/course-addTeacherAfterCourse";
import { ErrorsService } from "src/app/services/common/errors.service";
import { ConfirmComponent } from "src/app/components/confirm/confirm.component";
import { IConfirm } from "src/app/interfaces/confirm";
import { IError } from "src/app/interfaces/error.interface";

@Component({
  selector: "app-add-teacher-entry",
  templateUrl: "./add-teacher-entry.component.html",
  styleUrls: ["./add-teacher-entry.component.css"],
  providers: [ErrorsService]
})
export class AddTeacherEntryComponent implements OnInit {
  form: FormGroup;
  teacherListMain: any;
  teacherList: ITeacher;
  TeacherFreeTime: ITeacherFree;
  showTeachers: boolean = true;
  errors = new Array();
  errObject: any;
  param: any;
  errorList: IError[] = [];

  constructor(
    private fb: FormBuilder,
    private snackBar: SnackBarService,
    private errorService: ErrorsService,
    public translate: TranslateService,
    private dialog: MatDialog,
    private courseService: CourseService,
    private dialogRef: MatDialogRef<AddTeacherEntryComponent>,

    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    this.form = this.fb.group({
      CourseId: [this.data.Id],
      TeacherUserEncryptId: [null, Validators.compose([Validators.required])],
      CourseAllSessionId: [null, Validators.compose([Validators.required])]
    });
    this.getTeacherFreeTime(this.data.Id);
  }

  filterOptione(key) {
    this.teacherList = this.teacherListMain.filter(function (e) {
      return e.FirstName.includes(key) || e.LastName.includes(key)
    })
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  getTeacherFreeTime(id: number) {
    var data = {
      Id: id
    };
    this.courseService.getListIndeterminate(data).subscribe(
      res => {
        this.TeacherFreeTime = res;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  loadTeacher(e) {
    var data = {
      Id: this.data.Id,
      CourseAllSessionId: e.value
    };
    this.courseService.GetFreeTeacherAfterCourse(data).subscribe(
      res => {
        this.showTeachers = false;
        console.log(res);
        this.teacherListMain = res;
        this.teacherList = res;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  removeCourseTeacher() {
    var data = {
      CourseId: this.data.Id
    }
    let confirm: IConfirm = {
      accept: true,
      message: 'کاربر گرامی! در صورت حذف استاد از کلاس اگر حضور و غیاب برای استاد مورد نظر ثبت شده باشد، این اطلاعات نیز حذف خواهد گردید.',
      alert: null,
      yesLabel: this.translate.get("label.yes"),
      noLabel: this.translate.get("label.no")
    };
    this.dialog
      .open(ConfirmComponent, {
        width: "600px",
        data: confirm
      })
      .afterClosed()
      .subscribe(res => {
        if (res) {
          this.errors = new Array();
          this.courseService.RemoveTeacherFromCourse(data).subscribe(() => {
            this.snackBar.OpenSnackBar(
              'حذف استاد از کلاس با موفقیت انجام شد',
              "ok",
              5000,
              SoundEnum.beep
            );
          }, err => {
            // this.errObject = this.errorService.getError(err);
            // this.param = this.errorService.objectError(this.errObject);
            // this.errors = this.errorService.returnError(err);
            this.errorList = this.errorService.getErrorList(err.error);
          })
        }
      });


  }

  submit(data: IAddTeacherAfterCourse) {
    this.errors = new Array();
    this.courseService.AddTeacherAfterCourse(data).subscribe(
      () => {
        this.onNoClick();
        this.snackBar.OpenSnackBar(
          this.translate.get("success.registration"),
          "ok",
          5000,
          SoundEnum.beep
        );
      },
      err => {
        // this.errObject = this.errorService.getError(err);
        // this.param = this.errorService.objectError(this.errObject);
        // this.errors = this.errorService.returnError(err);
        this.errorList = this.errorService.getErrorList(err.error);
      }
    );
  }
}
